// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"f0c3c146","204":"961e1f49","212":"dfc0b0c3","263":"61b1f992","314":"78636828","453":"5655ea14","489":"40e82abd","497":"41a400db","527":"a097e0fd","533":"3507dc78","559":"be3ed07e","616":"72346a75","712":"12ce0919","845":"7234e28b"}[chunkId] + ".chunk.js";
};